export { EdpContractComponent } from "./edp-contract.component";
export {
    Contract,
    ContractFactory,
    Address,
    AddressFactory,
    BasicComponent,
    BasicComponentFactory
} from "./edp-contract.model";
